import { useQuery } from "@tanstack/react-query";
import { createLogger } from "logging";
import { useApi } from "providers";
import { useMeeting } from "providers";
import React, { PropsWithChildren, useMemo } from "react";

import { SuggestedAgendaItemContext } from "./SuggestedAgendaItemContext";

const logger = createLogger("SuggestedAgendaItemProvider");

export const SuggestedAgendaItemProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { suggestedAgendaItemsApi } = useApi();
  const { meetingId } = useMeeting();

  // prettier-ignore
  const suggestedAgendaItemsCount = useQuery({
    queryKey: [`Meeting|${meetingId}|SuggestedAgendaItemCount`],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      const data = await suggestedAgendaItemsApi.getCount(Number(meetingId), signal);
      logger.trace("Loaded:", data);
      return data;
    },
    enabled: !!meetingId,
  });

  const contextValue = useMemo(() => ({ suggestedAgendaItemsCount }), [suggestedAgendaItemsCount]);

  return <SuggestedAgendaItemContext.Provider value={contextValue}>{children}</SuggestedAgendaItemContext.Provider>;
};
